import type { StagedAction } from '../hooks/use-staged-actions'

// Mirrors the gateway's `braintrustPermalink` (apps/http-gateway/src/lib/
// share-to-braintrust) — the org/project are fixed, and only the history feed
// serves ready-made links, so surfaces holding a bare span id build it here.
const BRAINTRUST_ORG = 'highlightai'
const BRAINTRUST_PROJECT_ID = 'a7418d49-499e-43d3-90e8-ab213048b28a'

/**
 * Action metadata accumulates one permalink per authoring turn — sometimes a
 * single link, sometimes several joined by newlines. Return the latest.
 */
export function latestBraintrustSpanLink(value: string | undefined): string | undefined {
  return value
    ?.trim()
    .split(/[\s,]+/)
    .filter(Boolean)
    .at(-1)
}

export function braintrustSpanPermalink(spanId: string): string {
  const params = new URLSearchParams({
    object_type: 'project_logs',
    object_id: BRAINTRUST_PROJECT_ID,
    id: spanId,
  })
  return `https://www.braintrust.dev/app/${BRAINTRUST_ORG}/object?${params}`
}

/**
 * The action's authoring-turn permalink. The record's own metadata carries it
 * under either key spelling — take the latest. Fall back to the opener's
 * ready-made link (history feed), then to building one from the span id.
 */
export function resolveActionSpanLink(action: StagedAction, braintrustLink?: string): string | undefined {
  const metadataSpanLink = latestBraintrustSpanLink(
    action.metadata?.braintrustSpanLink ?? action.metadata?.braintrust_link,
  )
  return (
    metadataSpanLink ??
    braintrustLink ??
    (action.braintrustSpanId ? braintrustSpanPermalink(action.braintrustSpanId) : undefined)
  )
}
